import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ShowPhonesexDecider } from './Phonesex/ShowPhonesexDecider';
import BaukastenMenu from "./BaukastenMenu";
function TopMenu() {
  var _a = useState('closed'),
    position = _a[0],
    setPosition = _a[1];
  if (window.layoutSettings.hash !== '') {
    return /*#__PURE__*/React.createElement(BaukastenMenu, null);
  }
  function clickMenu(target) {
    setPosition('closed');
  }
  function togglePosition(evt) {
    evt.stopPropagation();
    if (position === 'closed') {
      setPosition('open');
    } else {
      setPosition('closed');
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: 'hamburgler',
    onClick: togglePosition,
    className: position
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faBars
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimes
  })), /*#__PURE__*/React.createElement("div", {
    id: 'categoryNav',
    className: 'c-navigation ' + position
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prodwidth center l-container h-center'
  }, /*#__PURE__*/React.createElement("p", {
    id: 'header',
    className: 'c-navigation__header'
  }, /*#__PURE__*/React.createElement("b", null, "Kategorien")), /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement(NavLink, {
    onClick: function () {
      clickMenu('home');
    },
    className: function (_a) {
      var isActive = _a.isActive;
      var isActiveClass = isActive || !!location.pathname.match(/^\/(seite\/\d+\/)?$/);
      return "c-navigation__link".concat(isActiveClass ? ' c-navigation__link--active active' : '');
    },
    to: {
      pathname: '/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Alle Girls"), /*#__PURE__*/React.createElement(NavLink, {
    onClick: function () {
      clickMenu('anal');
    },
    className: function (_a) {
      var isActive = _a.isActive;
      return "c-navigation__link".concat(isActive ? ' c-navigation__link--active active' : '');
    },
    to: {
      pathname: '/kategorie/anal/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Anale Grande"), /*#__PURE__*/React.createElement(NavLink, {
    onClick: function () {
      clickMenu('milf');
    },
    className: function (_a) {
      var isActive = _a.isActive;
      return "c-navigation__link ".concat(isActive ? ' c-navigation__link--active active' : '');
    },
    to: {
      pathname: '/kategorie/milf/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Die Milf machts"), /*#__PURE__*/React.createElement(NavLink, {
    onClick: function () {
      clickMenu('fetish');
    },
    className: function (_a) {
      var isActive = _a.isActive;
      return "c-navigation__link ".concat(isActive ? ' c-navigation__link--active active' : '');
    },
    to: {
      pathname: '/kategorie/fetisch/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Faszination Fetisch"), /*#__PURE__*/React.createElement(ShowPhonesexDecider, null, /*#__PURE__*/React.createElement(NavLink, {
    onClick: function () {
      clickMenu('telefonsex');
    },
    className: function (_a) {
      var isActive = _a.isActive;
      return "c-navigation__link ".concat(isActive ? ' c-navigation__link--active active' : '');
    },
    to: {
      pathname: '/telefonsex/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Telefonsex pur"))))));
}
export default TopMenu;